/**
 * Módulo para gestión de errores de validación
 */

export class ErrorManager {
    constructor() {
        this.errors = new Map();
    }

    /**
     * Añade un error para un campo específico
     */
    addError(formName, fieldName, message) {
        const key = `${formName}_${fieldName}`;
        this.errors.set(key, message);
        this.showFieldError(formName, fieldName, message);
    }

    /**
     * Elimina un error para un campo específico
     */
    removeError(formName, fieldName) {
        const key = `${formName}_${fieldName}`;
        this.errors.delete(key);
        this.hideFieldError(formName, fieldName);
    }

    /**
     * Limpia todos los errores de un formulario
     */
    clearFormErrors(formName) {
        // Limpiar errores del mapa
        for (const [key] of this.errors) {
            if (key.startsWith(formName + '_')) {
                this.errors.delete(key);
            }
        }
        
        // Ocultar todos los elementos de error del formulario
        const form = document.forms[formName];
        if (!form) return;
        
        const errorElements = form.querySelectorAll('[id$="_error"]');
        errorElements.forEach(errorEl => {
            errorEl.style.display = 'none';
        });
    }

    /**
     * Muestra el error de un campo específico
     */
    showFieldError(formName, fieldName, message) {
        const errorElement = document.getElementById(`${formName}_${fieldName}_error`);
        if (errorElement) {
            if (message) {
                errorElement.textContent = message;
            }
            errorElement.style.display = 'block';
            errorElement.classList.add('zfm-field-error');
        }
        
        // Añadir clase de error al campo
        const field = document.forms[formName]?.[fieldName];
        if (field) {
            if (field.nodeName) {
                field.classList.add('zfm-field-invalid');
            } else {
                // Es un grupo de campos (radio/checkbox)
                for (let i = 0; i < field.length; i++) {
                    field[i].classList.add('zfm-field-invalid');
                }
            }
        }
    }

    /**
     * Oculta el error de un campo específico
     */
    hideFieldError(formName, fieldName) {
        const errorElement = document.getElementById(`${formName}_${fieldName}_error`);
        if (errorElement) {
            errorElement.style.display = 'none';
            errorElement.classList.remove('zfm-field-error');
        }
        
        // Quitar clase de error del campo
        const field = document.forms[formName]?.[fieldName];
        if (field) {
            if (field.nodeName) {
                field.classList.remove('zfm-field-invalid');
            } else {
                // Es un grupo de campos (radio/checkbox)
                for (let i = 0; i < field.length; i++) {
                    field[i].classList.remove('zfm-field-invalid');
                }
            }
        }
    }

    /**
     * Obtiene todos los errores de un formulario
     */
    getFormErrors(formName) {
        const formErrors = new Map();
        for (const [key, message] of this.errors) {
            if (key.startsWith(formName + '_')) {
                const fieldName = key.substring(formName.length + 1);
                formErrors.set(fieldName, message);
            }
        }
        return formErrors;
    }

    /**
     * Verifica si un formulario tiene errores
     */
    hasFormErrors(formName) {
        for (const [key] of this.errors) {
            if (key.startsWith(formName + '_')) {
                return true;
            }
        }
        return false;
    }

}